// Global Instructions Rule Applied!

import { configureStore, combineReducers } from '@reduxjs/toolkit'
import authReducer from '../core/auth/authSlice'
import dealsReducer from './state_update_actions/deals/index.ts'
import contactsReducer from './state_update_actions/contacts/index.ts'
import companiesReducer from './state_update_actions/companies/index.ts'
import fundraisingReducer from './state_update_actions/fundraising/index.ts'
import fundsReducer from './state_update_actions/funds/index.ts'
import fundTransactionsReducer from './state_update_actions/fund_transactions/index.ts'
import capitalCallsReducer from './state_update_actions/capital_calls/index.ts'
import journalEntriesReducer from './state_update_actions/journal_entries/index.ts'
import investorStatementRunsReducer from './state_update_actions/investor_statement_runs/index.ts'
import dealExecutionReducer from './state_update_actions/deal_execution/index.ts'
import assetTransactionsReducer from './state_update_actions/asset_transactions/index.ts'
import lpAllocationReducer from './state_update_actions/lp_allocation/index.ts'
import lpsReducer from './state_update_actions/lps/index.ts'
import tranchesReducer from './state_update_actions/tranches/index.ts'
import tabReducer from '../store/slices/tabSlice'
import tasksReducer from '../store/slices/tasksSlice'
import interactionsReducer from './state_update_actions/interactions/index.ts'
import globalConfigsReducer from './state_update_actions/global_configs/index.ts'
import roundsReducer from './state_update_actions/rounds/index.ts'
import distributionListsReducer from './state_update_actions/distribution_lists/index.ts'
import emailReducer from './state_update_actions/email/index.ts'
import prospectsReducer from '../store/slices/prospectsSlice'
import menuAreaReducer from '../store/slices/menuAreaSlice.ts'
import activeRecordsReducer from './state_update_actions/active_records/index.ts'
import { activeRecordsMiddleware } from './middleware/activeRecordsMiddleware.ts'
import mobileRecentsReducer from '../core/app-layout/mobile/state/mobileRecentsSlice.ts'

export const store = configureStore({
  // combineReducers keeps each reducer's own action union; the flat map form
  // demands Reducer<S, UnknownAction>, which a reducer typed on its module's
  // actions is not once strictFunctionTypes checks parameters contravariantly.
  reducer: combineReducers({
    auth: authReducer,
    deals: dealsReducer,
    contacts: contactsReducer,
    companies: companiesReducer,
    fundraising: fundraisingReducer,
    funds: fundsReducer,
    fundTransactions: fundTransactionsReducer,
    capitalCalls: capitalCallsReducer,
    journalEntries: journalEntriesReducer,
    investorStatementRuns: investorStatementRunsReducer,
    dealExecution: dealExecutionReducer,
    assetTransactions: assetTransactionsReducer,
    lpAllocation: lpAllocationReducer,
    lps: lpsReducer,
    tranches: tranchesReducer,
    tabs: tabReducer,
    tasks: tasksReducer,
    interactions: interactionsReducer,
    globalConfigs: globalConfigsReducer,
    rounds: roundsReducer,
    distributionLists: distributionListsReducer,
    email: emailReducer,
    prospects: prospectsReducer,
    activeRecords: activeRecordsReducer,
    mobileRecents: mobileRecentsReducer,
    menuArea: menuAreaReducer
  }),
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE']
      },
      immutableCheck: {
        // Increase warning threshold to reduce noise - the middleware is still active but won't warn until 100ms
        warnAfter: 100
      }
    }).concat(activeRecordsMiddleware),
  devTools:
    process.env.NODE_ENV !== 'production'
      ? {
          name: 'Reservoir Portal',
          trace: true,
          traceLimit: 25
        }
      : false
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
